export default "__VITE_ASSET__BADBD4$s__"